import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ContentFormatter, Type } from "@ebscois/react-component-library";
import { StyledAnchor, StyledDialogDiv } from "./_styled";

export default function DialogProcessor({ supplemental }) {
  const [modalBody, setModalBody] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const processModal = (
    node,
    children,
    wrapperNode,
    processContentPage,
    processNodes
  ) => {
    const referenceId = node.attribs["data-reference-id"];
    const contentTitle = supplemental[referenceId]?.title;
    const content = supplemental[referenceId]?.data;

    if (!content) {
      // We were given a referenceId that doesn't exist, let's log it
      window?.DD_RUM?.addError(
        new Error(
          `Modal content was given a referenceId that does not exist, referenceId: ${referenceId}`
        ),
        {
          scope: "platform-content",
          team: "cd.mergeconflict",
        }
      );
    }

    return content && contentTitle ? (
      <StyledAnchor
        linkComponent={Link}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setModalBody(
            <StyledDialogDiv>
              <Type element="h2" color="primary">
                {contentTitle}
              </Type>
              <ContentFormatter preProcessors={[processContentPage()]}>
                {content}
              </ContentFormatter>
            </StyledDialogDiv>
          );
          setIsModalOpen(true);
        }}
      >
        {processNodes(wrapperNode, children)}
      </StyledAnchor>
    ) : (
      processNodes({ name: "span", type: "tag" }, children)
    );
  };

  const modalAssets = {
    modalBody,
    setModalBody,
    isModalOpen,
    setIsModalOpen,
  };

  return {
    modalAssets,
    processModal,
  };
}
